import { render, staticRenderFns } from "./RegisterCleaner.vue?vue&type=template&id=2c4e3751&scoped=true"
import script from "./RegisterCleaner.vue?vue&type=script&lang=js"
export * from "./RegisterCleaner.vue?vue&type=script&lang=js"
import style0 from "./RegisterCleaner.vue?vue&type=style&index=0&id=2c4e3751&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4e3751",
  null
  
)

export default component.exports